import { render, staticRenderFns } from "./VSwitch.vue?vue&type=template&id=1ac31b94&scoped=true&"
import script from "./VSwitch.vue?vue&type=script&lang=js&"
export * from "./VSwitch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ac31b94",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/sivaram/work/carthike/pushhike/pushhike-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1ac31b94')) {
      api.createRecord('1ac31b94', component.options)
    } else {
      api.reload('1ac31b94', component.options)
    }
    module.hot.accept("./VSwitch.vue?vue&type=template&id=1ac31b94&scoped=true&", function () {
      api.rerender('1ac31b94', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Common/VSwitch.vue"
export default component.exports